/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

const COb = require('./COb')
const Complexe = require('../types/Complexe')
const Ope = require('../types/Ope')
const Opef = require('../types/Opef')
const kernel = require('../kernel/kernel')
const CCbGlob = require('../kernel/CCbGlob')

// parmi toutes ces dépendances, on ne peut pas charger ici tous les objetTruc qui ont du
// objetTruc.prototype = new CCb()
// on commente ici et redéclare dans les méthodes qui les utilisent
// et qui pourraient peut-être passer dans un module séparé

// const CAppelFonction = require('./CAppelFonction')
// const CAppelFonctionComplexe = require('./CAppelFonctionComplexe')
// const CAppelFonctionNVar = require('./CAppelFonctionNVar')
// const CAppelFonctionComplexeNVar = require('./CAppelFonctionComplexeNVar')
// const CAppelFonctionInterne = require('./CAppelFonctionInterne')
// const CAppelFonctionInterneNVar = require('./CAppelFonctionInterneNVar')
// const CConstante = require('./CConstante')
// const CConstantei = require('./CConstantei')
// const CFonction = require('./CFonction')
// const CFonction2Var = require('./CFonction2Var')
// const CFonction3Var = require('./CFonction3Var')
// const CIntegraleDansFormule = require('./CIntegraleDansFormule')
// const CMoinsUnaire = require('./CMoinsUnaire')
// const COp = require('./COperation')
// const CProduitDansFormule = require('./CProduitDansFormule')
// const CPuissance = require('./CPuissance')
// const CResultatValeur = require('./CResultatValeur')
// const CResultatValeurComplexe = require('./CResultatValeurComplexe')
// const CVariableFormelle = require('./CVariableFormelle')
// const CSommeDansFormule = require('./CSommeDansFormule')
// const CCbNull = require('./CCbNull')

module.exports = CCb

/**
 * Classe ancêtre de tous les objets de type calcul pouvant être utilisés dans un
 * arbre binaire de calcul.
 * @constructor
 * @extends COb
 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
 * @returns {CCb}
 */
function CCb (listeProprietaire) {
  if (arguments.length === 0) COb.call(this) // Ajout version WebPack
  else {
    COb.call(this, listeProprietaire);
    // Ajout version 4.8 pour optimiser la fonction dependDe
    this.elementTestePourDependDe = null;
    this.dependDeElementTeste = false;
  }
}
CCb.prototype = new COb();
CCb.prototype.constructor = CCb;
CCb.prototype.superClass = "COb";
CCb.prototype.className = "CCb";

// Ajout version 4.8
/**
 * Fonction mémorisant la dépendance de l'objet par rapport à une objet déjà testé
 * @param {type} resultat
 * @returns {Boolean}
 */
CCb.prototype. memoriseDependance = function (resultat) {
  this.dependDeElementTeste = resultat;
  return resultat;
};

/**
 * Fonction rendant une chaîne de caractères représentant le calcul représenté
 * par this qui est un arbre binaire de calcul.
 * A redéfinir pour les desdendants.
 * Utiliser plutôt chaineCalculSansPar car le résultat peut contenir des parenthèses.
 * @param {Array} varFor : Un tableau représentant les variables formelles
 * pour une fonction de plusieurs variables.
 * @returns {String}
 */
CCb.prototype.chaineCalcul = function(varFor) {
  return "";
};
/**
 * Fonction rendant une chaîne de caractères sans parenthèses externes
 * représentant le calcul représenté  * par this qui est un arbre binaire de calcul.
 * A redéfinir pour les desdendants.
 * @param {Array} varFor : Un tableau représentant les variables formelles
 * pour une fonction de plusieurs variables.
 * @returns {String}
 */
CCb.prototype.chaineCalculSansPar = function(varFor) {
  return this.chaineCalcul(varFor);
};
/**
 * Sert à reconstituer une formule LaTeX à partir de son arbre binaire
 * conjointement à chaineLatexSansPar A redéfinir pour les descendants
 */
/**
 * Fonction rendant une chaîne de caractères représentant en laTeX le calcul représenté
 * par this qui est un arbre binaire de calcul.
 * A redéfinir pour les desdendants.
 * Utiliser plutôt chaineLatexSansPar car le résultat peut contenir des parenthèses.
 * @param {Array} varFor : Un tableau représentant les variables formelles
 * pour une fonction de plusieurs variables.
 * @returns {String}
 */
CCb.prototype.chaineLatex = function(varFor) {
  return this.chaineCalcul(varFor);
};
/**
 * Sert à reconstituer une formule à partir de son arbre binaire conjointement
 * à chaineCalcul A redéfinir pour les descendants
 */
/**
 * Fonction rendant une chaîne de caractères sans parenthèses externes
 * représentant en laTeX le calcul représenté
 * par this qui est un arbre binaire de calcul.
 * A redéfinir pour les desdendants.
 * @param {Array} varFor : Un tableau représentant les variables formelles
 * pour une fonction de plusieurs variables.
 * @returns {String}
 */
CCb.prototype.chaineLatexSansPar = function(varFor) {
  return this.chaineLatex(varFor);
};
/**
 * Renvoie true si le calcul est constant (c'est-à-dire nn'utilise pas de valeurs
 * dynamiques) sans faire appel à la fonction Rand().
 * @returns {Boolean}
 */
CCb.prototype.estConstant = function() {
  return false;
};
/**
 * Fonction renvoyant true si this est un calcul constant renvoyant la valeur 0.
 * Redéfinit dans CConstante.
 * @returns {Boolean}
 */
CCb.prototype.estConstante0 = function() {
  return false;
};
/**
 * Fonction renvoyant true si le calcul existe.
 * A redéfinir pour les descendants.
 * existe prend un paramètre boolean infoRandom
 * C'est dû à l'optimisation de la fonction de 3 variables si(test,
 * valeurSiVrai, valeurSiFaux) qui nécessite de connaître la valeur
 * du premier argument test pour savoir si le résultat existe ou non. Si test
 * renvoie 1, existe renvoie valeurSiVrai.existe(inforRandom)
 * et sinon ValeurSiFaux.existe(infoRandom)
 * @returns {Boolean}
 */
CCb.prototype.existe = function() {
  return true;
};
/**
 * Fonction à redéfinir pour tous les descendants.
 * Renvoie un clone de l'objet, listeSource étant la liste propriétaire de l'objet
 * et listeCible la liste propriétaire du clone à créer.
 * @param {CListeObjets} listeSource : La liste propriétaire de l'objet
 * @param {CListeObjets} listeCible : La liste propriétaire de l'objet clone à céer.
 * @returns {CCb}
 */
CCb.prototype.getClone = function(listeSource, listeCible) {
  return null;
};
/**
  * Fonction à redéfinir pour tous les descendants.
  * Renvoie une copie conforme de l'objet dans sa liste propriétaire.
  * Utilisé dans les calculs de dérivées.
 * @returns {CCb}
 */
CCb.prototype.getCopie = function() {
  return null;
};
// Revu par rapport à la version Java : Paramètre infoRandom supprimé car inutilisé
/**
 * Fonction utilisée pour savoir si une fonction utilisateur existe.
 * Est différent de existe à cause de la fonction de 3 variables si(test, valeurSiVrai, valeurSiFaux)
 * @returns {boolean}
 */
CCb.prototype.existePourFonc = function() {
  return this.existe();
};
/**
 * Fonction renvoyant dans le cas d'un opérateur le membre de gauche et sinon this.
 * A redéfinir pour certians descendants.
 * @returns {CCb}
 */
CCb.prototype.membreGauche = function() {
  return this;
};
/**
 * Fonction renvoyant dans le cas d'un opérateur le membre de droite et sinon this.
 * A redéfinir pour certians descendants.
 * @returns {CCb}
 */
CCb.prototype.membreDroit = function() {
  return this;
};
/**
 * Fonction servant pour les fonctions à savoir quel est le nombre de variables.
 * @returns {Integer}
 */
CCb.prototype.nombreVariables = function() {
  return 0;
};
/**
 * Fonction renvoyant le résultat du calcul.
 * A redéfinir pour les descendants.
 * @param {Boolean } infoRandom :  true si les calculas aléatoires avec rand
 * @returns {number}
 */
CCb.prototype.resultat = function(infoRandom) {
  throw new Error("Appel de Ccb.resultat");
};
// Ajout pour la version 2.0 calculs sur les complexes.
// Le résultat est renvoyé dans z
/**
 * Fonction renvoyant dans zRes le résultat d'un calcul complexe.
 * A redéfinir pour les descendnats.
 * @param {Boolean} infoRandom : true si les calculas aléatoires avec rand
 * @param {Complexe} zRes : Le résultat complexe du calcul
 * @returns {undefined}
 */
CCb.prototype.resultatComplexe = function(infoRandom, zRes) {
  zRes.x = this.resultat(infoRandom);// Par défaut on suppose le calcul réel
  zRes.y = 0;
};
/**
 * Appelé lors des appels de fonctions pour fournir le résultat du calcul.
 * A redéfinir pour les descendants.
 * @param {Boolean} infoRandom : true si les calculas aléatoires avec rand
 * @param {Array} valeurparametre : un tableau donnant les valeurs des paramètres pour une
 * fonction de une ou plusieurs variabels.
 * @returns {Number}
 */
CCb.prototype.resultatFonction = function(infoRandom, valeurparametre) {
  return this.resultat(infoRandom);
};
/**
 * Appelé lors des appels de fonctions pour fournir le résultat complexe du calcul.
 * A redéfinir pour les descendants.
* @param {Boolean} infoRandom : true si les calculas aléatoires avec rand
 * @param {Array} valeurParametre : un tableau donnant les valeurs des paramètres pour une
 * @param {type} zRes : Le complexe contenant le résultat.
 * @returns {undefined}
 */
CCb.prototype.resultatFonctionComplexe = function(infoRandom, valeurParametre,
    zRes) {
  this.resultatComplexe(infoRandom, zRes);
};

CCb.prototype.initialisePourDependance = function() {
  this.elementTestePourDependDe = null;
  this.elementTestePourDependDePourRec = null;
};

/**
 * Fonction renvoyant true si le calcul dépend de p.
 * A redéfinir pour les descendants.
 * @param {CElementBase} p
 * @returns {Boolean}
 */
CCb.prototype.dependDe = function(p) {
  this.elementTestePourDependDe = p;
  return false;
};
/**
 * La fonction suivante renverra le même résultat que DependDe sauf dans le
 * cas où le calcul fait réferrence à la fonction Rand de génération d'un
 * nombre aléatoire
 * @param {CElementBase} p
 * @returns {Boolean}
 */
CCb.prototype.dependDePourBoucle = function(p) {
  return false;
};
/**
 * Fonction renvoyant true si l'arbre pointé par this conteint un appel de variable
 * formelle, ind étant l'indice de la variable pour une fonction de plusieurs variables.
 * A redéfinir pour tous les descendants.
 * @param {Integer} ind : Indice de la variable pour les fonctions à plusieurs variables.
 * @returns {Boolean}
 */
CCb.prototype.dependDeVariable = function(ind) {
  return this.operande.dependDeVariable(ind);
};

/**
 * Fonction ajoutant à liste tous les operandes de
 * multiplication issus d'un même noeud de multiplication.
 * @param {Array} liste
 * @returns {undefined}
 */
CCb.prototype.ajouteOperateursMult = function(liste) {
  var nat = this.nature();
  if (nat === CCbGlob.natOperation) {
    if (this.Ope === Ope.Mult) {
			// COperation op = (COperation) this;
      this.operande1.ajouteOperateursMult(liste);
      this.operande2.ajouteOperateursMult(liste);
    } else
      liste.push(this);
  } else
    liste.push(this);
};
/**
 * Fonction ajoutant à liste tous les operandes d'addition
 * issus d'un même noeud de multiplication.
 * @param {Array} liste
 * @returns {undefined}
 */
CCb.prototype.ajouteOperateursPlus = function(liste) {
  var nat = this.nature();
  if (nat === CCbGlob.natOperation) {
    if (this.Ope === Ope.Plus) {
      this.operande1.ajouteOperateursPlus(liste);
      this.operande2.ajouteOperateursPlus(liste);
    } else
      liste.push(this);
  } else
    liste.push(this);
};
/**
 * Fonction fournissant un calcul dans lequel tous les CResultatValeur
 * et CResultatValeurComplexes sont remplacés par une constante dont la valeur
 * est le résultat du CResultatValeur ou CResultatValeurComplexes.
 * @returns {CCb}
 */
CCb.prototype.calculAvecValeursRemplacees = function() {
  return this;
};
/**
 * Renvoie un calcul normalisé équivalent au calcul this.
 * Si rempval est true les appels à des CResultatValeur ou CResultatValeurComplexe
 * sont remplacés par une constante.
 * @param {Boolean} rempval
 * @param {Boolean} sousdivnorm : Si true, les soustractions sont remplacées par des additions d'opposés
 * @param {Boolean} rempDecParFrac : Si, true, les nombres décimaux (avec au plus 9 décimales) et la fraction irréductible
 * qui les représentent sont considérés comme équivalents.
 * et les divisions pas des multiplications par l'inverse.
 * @returns {CCb}
 */
CCb.prototype.calculNormalise = function(rempval, sousdivnorm, rempDecParFrac) {
  const CAppelFonction = require('./CAppelFonction')
  const CAppelFonctionNVar = require('./CAppelFonctionNVar')
  const CConstante = require('./CConstante')
  const CConstantei = require('./CConstantei')
  const CFonction = require('./CFonction')
  const CFonction2Var = require('./CFonction2Var')
  const CFonction3Var = require('./CFonction3Var')
  const CMoinsUnaire = require('./CMoinsUnaire')
  const COp = require('./COperation')
  const CPuissance = require('./CPuissance')

  var liste = this.listeProprietaire;
  var nat = this.nature();
  if (nat === CCbGlob.natOperation) {
    // COperation op = (COperation) this;
    var calcOperande1 = this.operande1.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    var calcOperande2 = this.operande2.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    var natop1 = calcOperande1.nature();
    var natop2 = calcOperande2.nature();
    if (this.Ope === Ope.Moin) {
      // On remplace les a - 0 par a
      if (rempval) {
        if ((natop2 === CCbGlob.natConstante)) {
          if (calcOperande2.valeur === 0) return calcOperande1;
        }
        // On remplace les 0 - a par - a ou par abs(a) si a est un moins unaire
        if ((natop1 === CCbGlob.natConstante)) {
          // CConstante resval = (CConstante) calcOperande1;
          if (calcOperande1.valeur === 0) {
            if (calcOperande2.nature() === CCbGlob.natMoinsUnaire) return calcOperande2.operande;
            return new CMoinsUnaire(liste, calcOperande2);
          }
        }
        // On remplace a - (-b) par a + b
        if (natop2 === CCbGlob.natMoinsUnaire) {
          // CMoinsUnaire mun = (CMoinsUnaire) calcOperande2;
          // return new COperation(liste, calcOperande1, mun.operande, Ope.Plus); // Modifié version 4.7.2.5
          return new COp(liste, calcOperande1, calcOperande2.operande,
            Ope.Plus).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
        }
      }
      // On remplace les a - b par a + (-b)
      if (sousdivnorm) return new COp(liste, calcOperande1,
        new CMoinsUnaire(liste, calcOperande2), Ope.Plus);
      else return new COp(liste, calcOperande1, calcOperande2, Ope.Moin);
    }
    if (this.Ope === Ope.Divi) {
      // Si on est en mode remplacement de valeurs et que le dénominateur est un résultat de valeur 1 on simplifie
      if (rempval) {
        if (natop2 === CCbGlob.natConstante) {
          if (calcOperande2.valeur === 1) {
            // Pour 1/1 on renvoie 1
            if (natop1 === CCbGlob.natConstante) {
              if (calcOperande1.valeur === 1) return new CConstante(liste, 1);
            }
            return calcOperande1;
          }
        }
        // Si le numérateur est une constante qui vaut 1 on garde le quotient
        if (natop1 === CCbGlob.natConstante) {
          // CConstante resval = (CConstante) calcOperande1;
          var r = calcOperande1.valeur;
          if (r === 1) {
            if (calcOperande2.nature() === CCbGlob.natMoinsUnaire) {
              return new CMoinsUnaire(liste, new COp(liste,
              new CConstante(liste,  1), calcOperande2.operande, Ope.Divi)
                .calculNormalise(rempval, sousdivnorm, rempDecParFrac));
            }
            else return new COp(liste, new CConstante(liste,  1), calcOperande2, Ope.Divi);
          }
          // S'il vaut 0 on renvoie un CResultatValeur contenant 0
          if (r === 0) return new CConstante(liste, 0);
        }
        // Si le numérateur ou le dénominateur sont des moins unaires on simplifie
        if (natop1 === CCbGlob.natMoinsUnaire) {
          // CMoinsUnaire mun1 = (CMoinsUnaire) calcOperande1;
          if (natop2 === CCbGlob.natMoinsUnaire) {
            // CMoinsUnaire mun2 = (CMoinsUnaire) calcOperande2;
            if (sousdivnorm) return new COp(liste, calcOperande1.operande,
                new COp(liste, new CConstante(liste, 1),
                calcOperande2.operande, Ope.Divi), Ope.Mult).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
            else return new COp(liste, calcOperande1.operande, calcOperande2.operande,
              Ope.Divi).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
          }
          if (sousdivnorm) return new CMoinsUnaire(liste, new COp(liste, calcOperande1.operande,
              new COp(liste, new CConstante(liste, 1),
              calcOperande2, Ope.Divi), Ope.Mult)).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
          else return new CMoinsUnaire(liste, new COp(liste, calcOperande1.operande, calcOperande2,
            Ope.Divi).calculNormalise(rempval, sousdivnorm, rempDecParFrac));
        }
        if (natop2 === CCbGlob.natMoinsUnaire) {
          // CMoinsUnaire mun2 = (CMoinsUnaire) calcOperande2;
          if (sousdivnorm) return new CMoinsUnaire(liste, new COp(liste, calcOperande1,
              new COp(liste, new CConstante(liste, 1),
              calcOperande2.operande, Ope.Divi), Ope.Mult)).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
          else return new CMoinsUnaire(liste, new COp(liste, calcOperande1,
              calcOperande2.operande, Ope.Divi).calculNormalise(rempval, sousdivnorm, rempDecParFrac));
        }
      }
      // On remplace (-a)/b par - (a/b)
      // Si le numérateur ou le dénominateur sont des moins unaires on simplifie
      if (natop1 === CCbGlob.natMoinsUnaire) {
        // CMoinsUnaire mun1 = (CMoinsUnaire) calcOperande1;
        var natnum = calcOperande1.operande.nature();
        // Si le numérateur est une constante -1 on renvoie -(1/denominateur)
        if (natnum === CCbGlob.natConstante) {
          var c = calcOperande1.operande;
          if (c.valeur === 1)
            return new CMoinsUnaire(liste, new COp(liste, new CConstante(liste, 1),
            calcOperande2, Ope.Divi));
        }
        if (sousdivnorm) return new CMoinsUnaire(liste, new COp(liste, calcOperande1.operande,
            new COp(liste, new CConstante(liste, 1),
            calcOperande2, Ope.Divi), Ope.Mult)).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
        else return new CMoinsUnaire(liste,
            new COp(liste, calcOperande1.operande, calcOperande2, Ope.Divi)).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
      }
      // Fin ajout version 4.7.2.5
      // On remplace a / b par a * (1/b) sauf si a est une constante à 1
      if (natop1 === CCbGlob.natConstante) {
        // CConstante cons = (CConstante) calcOperande1;
        if (calcOperande1.valeur === 1) return new COp(liste, calcOperande1, calcOperande2, Ope.Divi);
      }
      // Si l'opérande de gauche est un produit dont un des facteurs est une constante 1
      // On le remplace par le facteur de gauche
      if (natop1 === CCbGlob.natOperation) {
        // COperation op1 = (COperation) calcOperande1;
        if (calcOperande1.Ope === Ope.Mult) {
          if (calcOperande1.operande1.nature() === CCbGlob.natConstante) {
            if( calcOperande1.operande1.valeur === 1) return new COp
              (liste, calcOperande1.operande2, calcOperande2,
                    Ope.Divi).calculNormalise(rempval,sousdivnorm, rempDecParFrac, rempDecParFrac);
          }
          if (calcOperande1.operande2.nature() === CCbGlob.natConstante) {
            if(calcOperande1.operande2.valeur === 1) return new COp
              (liste, calcOperande1.operande1, calcOperande2,
                    Ope.Divi).calculNormalise(rempval,sousdivnorm, rempDecParFrac, rempDecParFrac);
          }
        }
      }
      if (sousdivnorm) return new COp(liste, calcOperande1,new COp(liste,
        new CConstante(liste, 1), calcOperande2, Ope.Divi), Ope.Mult);
      else return new COp(liste, calcOperande1, calcOperande2, Ope.Divi);
    }
    if (this.Ope === Ope.Plus) {
      if (rempval) {
        if (natop1 === CCbGlob.natConstante) {
          if (calcOperande1.valeur === 0) return calcOperande2;
        }
        if (natop2 === CCbGlob.natConstante) {
          if (calcOperande2.valeur === 0) return calcOperande1;
        }
      }
      if (sousdivnorm) return new COp(liste, calcOperande1, calcOperande2, Ope.Plus);
      else {
        // On remplace a + (-b) par a - b
        if (natop2 === CCbGlob.natMoinsUnaire) {
          // CMoinsUnaire mun2 = (CMoinsUnaire) calcOperande2;
          return new COp(liste, calcOperande1, calcOperande2.operande, Ope.Moin).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
        }
      }
    }
    if (this.Ope === Ope.Mult) {
      if (rempval) {
        // Il  faut faire "remonter" les moins unaires le plus haut possible
        if (natop1 === CCbGlob.natMoinsUnaire) {
          // CMoinsUnaire mun1 = (CMoinsUnaire) calcOperande1;
          if (natop2 === CCbGlob.natMoinsUnaire) {
            // CMoinsUnaire mun2 = (CMoinsUnaire) calcOperande2;
            return new COp(liste, calcOperande1.operande, calcOperande2.operande,
              Ope.Mult).calculNormalise(rempval, sousdivnorm, rempDecParFrac);
          }
          else return new CMoinsUnaire(liste,
              new COp(liste, calcOperande1.operande, calcOperande2,
              Ope.Mult).calculNormalise(rempval, sousdivnorm, rempDecParFrac));
        }
        else {
          if (natop2 ===  CCbGlob.natMoinsUnaire) {
          // CMoinsUnaire mun2 = (CMoinsUnaire) calcOperande2;
          return new CMoinsUnaire(liste, new COp(liste, calcOperande1,
          calcOperande2.operande, Ope.Mult).calculNormalise(rempval, sousdivnorm, rempDecParFrac));
          }
        }
        if (natop1 === CCbGlob.natConstante) {
          r = calcOperande1.valeur;
          if (r === 1) return calcOperande2;
          if (r === 0) return new CConstante(liste, 0);
        }
        if (natop2 === CCbGlob.natConstante) {
          // CConstante resval2 = (CConstante) calcOperande2;
          r = calcOperande2.valeur;
          if (r === 1) return calcOperande1;
          if (r === 0) return new CConstante(liste, 0);
        }
        return new COp(liste, calcOperande1, calcOperande2, Ope.Mult);
      }
    }
    // Autres cas . Rien  à simplifier et on simplifie seulement les opérandes.
    return new COp(liste, calcOperande1, calcOperande2, this.Ope);
  }
  if (nat === CCbGlob.natResultatValeur) {
    // CResultatValeur rv = (CResultatValeur) this;
    if (rempval) return new CConstante(liste, this.valeurAssociee.rendValeur());
    else return this;
  }
  if (nat === CCbGlob.natResultatValeurComplexe) {
    // CResultatValeurComplexe rv = (CResultatValeurComplexe) this;
    if (rempval) {
      var z = new Complexe();
      this.resultatComplexe(false, z);
      if (z.y === 0) return new CConstante(liste, this.valeurAssociee.rendValeur());
      else return new COp(liste, new CConstante(liste, z.x),
          new COp(liste, new CConstante(liste, z.y),
          new CConstantei(liste), Ope.Mult), Ope.Plus);
    }
    else
      return this;
  }
  if (nat === CCbGlob.natPuissance) {
    // Amélioration version 4.7.9 : Remplace a^1 par a
    var calcPui = this.exposant.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    var natexp = calcPui.nature();
    if (natexp === CCbGlob.natConstante) {
      var res = calcPui.valeur;
      if (res === 1) return this.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    }
    return new CPuissance(liste, this.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac), calcPui);
  }
  if (nat === CCbGlob.natFonction) {
    // CFonction fon = (CFonction) this;
    switch (this.Opef) {
      case Opef.Left:
      case Opef.LeftC:
        return this.operande.membreGauche().calculNormalise(rempval, sousdivnorm, rempDecParFrac);
      case Opef.Right:
      case Opef.RightC:
        return this.operande.membreDroit().calculNormalise(rempval, sousdivnorm, rempDecParFrac);
      default :
        return new CFonction(liste, this.Opef, this.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac));
    }
  }
  if (nat === CCbGlob.natAppelFonction) {
    return new CAppelFonction(liste, this.fonctionAssociee,
        this.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac));
  }
  if (nat === CCbGlob.natFonction2Var) {
    var op = new Array(2);
    op[0] = this.operande1.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    op[1] = this.operande2.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    return new CFonction2Var(liste, this.Opef, op[0], op[1]);
  }
  if (nat === CCbGlob.natFonction3Var) {
    op = new Array(3);
    op[0] = this.operande1.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    op[1] = this.operande2.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    op[2] = this.operande3.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    return new CFonction3Var(liste, this.Opef, op[0], op[1],
        op[2]);
  }
  if (nat === CCbGlob.natAppelFonctionNVar) {
    op = new Array(this.nbVar);
    for (var i = 0; i < this.nbVar; i++)
      op[i] = this.operande[i].calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    return new CAppelFonctionNVar(liste, this.nbVar, this.fonctionAssociee,
        op);
  }
  if (nat === CCbGlob.natMoinsUnaire) {
    // On remplace -(-b) par b
    var calcOperande = this.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
    if (rempval) {
      natop1 = calcOperande.nature();
      if (natop1 === CCbGlob.natMoinsUnaire) {
        return calcOperande.operande.calculNormalise(rempval, sousdivnorm, rempDecParFrac);
      }
      if (natop1 === CCbGlob.natConstante) {
        r = calcOperande.valeur;
        if (r === 0) return new CConstante(liste, 0);
      }
    }
    return new CMoinsUnaire(liste,  calcOperande);
  }
  // Ajout version 5.1.3
  if (rempDecParFrac && nat === CCbGlob.natConstante) {
    // CConstante co  = (CConstante) this;
    var va = this.valeur;
    if (va === Math.floor(va)) return this;
    var n = Math.floor(va*Math.pow(10, 9)+0.5);
    var d = 1000000000;
    if (!kernel.zero13(va-n/Math.pow(10, 9))) return this;
    var g = kernel.pgcd(n, 1000000000);
    var num = n/g;
    var den  = d/g;
    if (sousdivnorm) {
      if (num === 1) return new COp(liste,new CConstante(liste,1),new CConstante(liste,d/g),Ope.Divi);
      else return new COp(liste,new CConstante(liste, num),new COp(liste,new CConstante(liste,1),
        new CConstante(liste,den),Ope.Divi),Ope.Mult);
    }
    else return new COp(liste,new CConstante(liste, num), new CConstante(liste,den), Ope.Divi);
  }

  // Dans les autres cas on renvoie le même calcul
  return this;
};

/**
 * Fonction renvayant true si this est équivalent à calc
 * Deux calculs sont équivalents s'ils contiennent les mêmes opérateurs
 * sans tenier compte de l'odre des additions algébriques ou des multiplications.
 * Avant appel, this et calc doivent avoir été normalisés de façon
 * que this et calc ne contiennent que des additions et divisions.
 * @param {CCb} calc : le calcul dont on teste l'équivalence avec this.
 * @returns {Boolean}
 */
CCb.prototype.estEquivalentA = function(calc) {
  var nat1 = this.nature();
  var nat2 = calc.nature();
  if (nat1 !== nat2)
    return false;
  if (nat1 === CCbGlob.natConstante) {
    return this.valeur === calc.valeur;
  }
  if (nat1 === CCbGlob.natMoinsUnaire) {
    return this.operande.estEquivalentA(calc.operande);
  }
  if (nat1 === CCbGlob.natFonction) {
    return (Opef.estEquivalent(this.Opef, calc.Opef)) && this.operande.estEquivalentA(calc.operande);
  }
  if (nat1 === CCbGlob.natAppelFonction) {
    return (this.fonctionAssociee === calc.fonctionAssociee) && this.operande.estEquivalentA(calc.operande);
  }
  if (nat1 === CCbGlob.natFonction2Var) {
    return (this.Opef === calc.Opef) && this.operande1.estEquivalentA(calc.operande1)
        && this.operande2.estEquivalentA(calc.operande2);
  }
  if (nat1 === CCbGlob.natFonction3Var) {
    return (this.Opef === calc.Opef) && this.operande1.estEquivalentA(calc.operande1)
        && this.operande2.estEquivalentA(calc.operande2)
        && this.operande3.estEquivalentA(calc.operande3);
  }
  if (nat1 === CCbGlob.natAppelFonctionNVar) {
    if (this.fonctionAssociee !== calc.fonctionAssociee) return false;
    var op1 = new Array(this.nbVar);
    for (var i = 0; i < this.nbVar; i++)
      op1[i] = this.operande[i];
    var op2 = new CCb[calc.nbVar];
    for (i = 0; i < calc.nbVar; i++)
      op2[i] = calc.operande[i];
    var res = true;
    for (i = 0; i < this.nbVar; i++)
      res = res && op1[i].estEquivalentA(op2[i]);
    return res;
  }
  if (nat1 === CCbGlob.natVariableFormelle) {
    // CVariableFormelle for1 = (CVariableFormelle) this;
    // CVariableFormelle for2 = (CVariableFormelle) calc;
    return this.indvar === calc.indvar;
  }
  if (nat1 === CCbGlob.natOperation) {
    // COperation op1 = (COperation) this;
    // COperation op2 = (COperation) calc;
    var natop1 = this.Ope;
    var natop2 = calc.Ope;
    if (natop1 !== natop2) {
      if (natop1 === Ope.InfOuEgal) {
        // a <= b équivalent à b>= a)
        if (natop2 === Ope.SupOuEgal)
          return (this.operande1.estEquivalentA(calc.operande2) && this.operande2.estEquivalentA(calc.operande1));
        else return false; // Rajouté version 4.7.2
      }
      else {
        if (natop1 === Ope.Inf) {
        // a < b équivalent à b > a)
          if (natop2 === Ope.Sup)
            return (this.operande1.estEquivalentA(calc.operande2) && this.operande2.estEquivalentA(calc.operande1));
          else return false; // Rajouté version 4.7.2
        }
        else {
          if (natop1 === Ope.SupOuEgal) {
            // a >= b équivalent à b <= a)
            if (natop2 === Ope.InfOuEgal)
              return (this.operande1.estEquivalentA(calc.operande2) && this.operande2.estEquivalentA(calc.operande1));
            else return false; // Rajouté version 4.7.2
          }
          else {
            if (natop1 === Ope.Sup) {
              // a > b équivalent à b < a)
              if (natop2 === Ope.Inf)
                return (this.operande1.estEquivalentA(calc.operande2) && this.operande2.estEquivalentA(calc.operande1));
              else return false; // Rajouté version 4.7.2
            }
            else return false;
          }
        }
      }
    }
    // Les deux opérateurs sont les mêmes
    if (natop1 === Ope.Plus) {
      // Il faut vérifier que tous les opérandes sous-jascents sont
      // équivalents
      var list1 = [];
      var list2 = [];
      this.ajouteOperateursPlus(list1);
      calc.ajouteOperateursPlus(list2);
      if (list1.length !== list2.length) return false;
      for (i = 0; i < list1.length; i++) {
        var c1 = list1[i];
        var trouve = false;
        for (var j = 0; j < list2.length; j++) {
          var c2 = list2[j];
          if (c1.estEquivalentA(c2)) {
            trouve = true;
            list2.splice(j,1);
            break;
          }
        }
        if (!trouve)
          return false;
        else {
          list1.splice(i,1);
          i--; // Car le terme d'indice i a été retiré
        }
      }
      return true;
    }
    if (natop1 === Ope.Mult) {
      // Il faut vérifier que tous les opérandes sous-jascents sont
      // équivalents
      list1 = [];
      list2 = [];
      this.ajouteOperateursMult(list1);
      calc.ajouteOperateursMult(list2);
      if (list1.length !== list2.length) return false;
      for (i = 0; i < list1.length; i++) {
        c1 = list1[i];
        trouve = false;
        for (j = 0; j < list2.length; j++) {
          c2 = list2[j];
          if (c1.estEquivalentA(c2)) {
            trouve = true;
            list2.splice(j,1);
            break;
          }
        }
        if (!trouve) return false;
        else {
          list1.splice(i,1);
          i--; // Car le terme d'indice i a été retiré
        }
      }
      return true;
    }
    // a = b équivalent à b = a
    if ((natop1 === Ope.Egalite) || (natop1 === Ope.And) || (natop1 === Ope.Or)) {
      return (this.operande1.estEquivalentA(calc.operande1) && this.operande2.estEquivalentA(calc.operande2))
          || (this.operande1.estEquivalentA(calc.operande2) && this.operande2.estEquivalentA(calc.operande1));
    }
    // Dans les autres cas (division comprise, pour être équivalent les
    // opérandes respectifs
    // doivent être équivalents
    return (this.operande1.estEquivalentA(calc.operande1))
        && (this.operande2.estEquivalentA(calc.operande2));
  }
  if (nat1 === CCbGlob.natPuissance) {
    return (this.operande.estEquivalentA(calc.operande) && this.exposant.estEquivalentA(calc.exposant));
  }
  if (nat1 === CCbGlob.natConstantei) return true;
  if (nat1 === CCbGlob.natResultatValeur) {
    return this.valeurAssociee === calc.valeurAssociee; // Attention test d'identité en JavaScript
  }
  if (nat1 === CCbGlob.natResultatValeurComplexe) {
    return this.valeurAssociee === calc.valeurAssociee;
  }
  return false;
};
/**
 * Renvoie true si this est un produit factorisé par calc ou simplement équivalent à calc
 * ou à son opposé.
 * Avant appel, this et calc doivent être rendus normalisés pour pouvoir reconnaître
 * les réductions au même dénominateur.
 * @param {CCb} calc : Le calcul dont on etste si c'est un facteur commun à this.
 * @returns {Boolean}
 */
CCb.prototype.estFactorisePar = function(calc) {
  var nat1,nat2,natop1,natop2,list1,list2,i,j,c1,c2,trouve;
  nat1 = this.nature();
  if (nat1 === CCbGlob.natMoinsUnaire) {
    return this.operande.estFactorisePar(calc);
  }
  else {
    if (nat1 === CCbGlob.natOperation) {
      // COperation op1 = (COperation) this;
      natop1 = this.Ope;
      if ((natop1 === Ope.InfOuEgal) || (natop1 === Ope.Inf) || (natop1 === Ope.SupOuEgal) || (natop1 === Ope.Sup)
          || (natop1 === Ope.Egalite) || (natop1 === Ope.Diff)) {
        return ((this.operande1.estFactorisePar(calc) && this.operande2.estConstante0()) || (this.operande2.estFactorisePar(calc) && this.operande1.estConstante0()));
      }
      if (natop1 === Ope.Mult) {
        // Il faut vérifier si un des facteurs du produit et des facteurs sous-jascents est équivalent à calc
        list1 = [];
        list2 = [];
        this.ajouteOperateursMult(list1);
        nat2 = calc.nature();
        if (nat2 !== CCbGlob.natOperation) list2.push(calc);
        else {
          natop2 = calc.Ope;
          if (natop2 === Ope.Mult) calc.ajouteOperateursMult(list2);
          else list2.push(calc);
        }
        if (list1.length < list2.length) return false;
        for (i = 0; i < list2.length; i++) {
          c2 = list2[i];
          trouve = false;
          for (j = 0; j < list1.length; j++) {
            c1 = list1[j];
            if (c1.estEquivalentA(c2)) {
              trouve = true;
              list1.splice(j,1);
              break;
            }
          }
          if (!trouve) return false;
          else {
            list2 .splice(i,1);
            i--; // Car le terme d'indice i a été retiré
          }
        }
        return true;
      }
    }
    return this.estEquivalentA(calc);
  }
};
/**
 * Fonction renvoyant true si le calcul est dérivable.
 * A redéfinir pour les descendants pour lesquels ce n'est pas dérivabel.
 * @returns {Boolean}
 */
CCb.prototype.deriveePossible = function() {
  return true;
};


// WEBPACK FOOTER //
// ./src/objets/CCb.js